import { useSelector } from "@/store";

export function useTextOverrides() {
  return useSelector(
    (state) => state.channelConfig.appVariantSettings?.textOverrides ?? {}
  );
}
